'use client';

import dynamic from 'next/dynamic';
import { useEffect, useState } from 'react';

const FooterClient = dynamic(
  () => import('@/components/layout/new/FooterClient').then((mod) => mod.FooterClient),
  { ssr: false }
);

export default function DeferredFooter() {
  const [shouldRender, setShouldRender] = useState(false);
  const [data, setData] = useState(null);

  useEffect(() => {
    if (shouldRender) return;

    const reveal = () => setShouldRender(true);
    const cleanupFns = [];
    const events = ['pointerdown', 'keydown', 'wheel', 'touchstart'];

    events.forEach((eventName) => {
      window.addEventListener(eventName, reveal, {
        once: true,
        passive: true,
      });
      cleanupFns.push(() => window.removeEventListener(eventName, reveal));
    });

    const fallbackId = window.setTimeout(reveal, 15000);
    cleanupFns.push(() => window.clearTimeout(fallbackId));

    return () => cleanupFns.forEach((cleanup) => cleanup());
  }, [shouldRender]);

  useEffect(() => {
    if (!shouldRender || data) return;

    const controller = new AbortController();

    fetch('/api/footer', { signal: controller.signal })
      .then((response) => (response.ok ? response.json() : null))
      .then((payload) => {
        if (payload?.data) setData(payload.data);
      })
      .catch(() => {});

    return () => controller.abort();
  }, [data, shouldRender]);

  if (!shouldRender || !data) return null;

  return <FooterClient data={data} />;
}
